import React, { ReactElement } from 'react';
import { RouteProps } from 'react-router-dom';
import Footer from 'components/footer/footer';
import Header from 'components/header/header';
import { Helmet } from 'react-helmet';

interface MainLayoutProps extends RouteProps {
  theme?: 'white' | 'blue' | 'charcoal';
  position?: 'absolute' | 'relative';
  hideArticles?: boolean;
  hideBrandStory?: boolean;
}

export default function MainLayout(props: MainLayoutProps): ReactElement {
  const { theme, position } = props;

  return (
    <div className='main-layout'>
      <Helmet>
        <title>BestPark</title>
        <meta name='description' content='Best way to stay!' />
        <meta property='og:image' content='/favicon.ico' />
        <link rel='icon' href='/favicon.ico' />
      </Helmet>
      <Header theme={theme} position={position} />
      <div className='layout-content'>{props.children}</div>
      <Footer />
    </div>
  );
}
